// TODO - remove lint disable when editing this file
/* eslint-disable */
import { createReducer } from 'redux-ramda'
import { always, assoc, path, pipe, either, pathOr } from 'ramda'
import { createAction } from 'redux-actions'
import { ACTION_INIT, errorAction } from './commonActions'
import { withSideEffects } from '~/redux/reduxSideEffects'

export const ACTION_INIT_TANSA = 'ellipsis.tansa.initialize'
export const initializeTansa = createAction(ACTION_INIT_TANSA)

export const ACTION_TANSA_LOAD_SUCCESS = 'ellipsis.tansa.loaded'
export const tansaLoadSuccess = createAction(ACTION_TANSA_LOAD_SUCCESS)

export const ACTION_TANSA_LOAD_ERROR = 'ellipsis.tansa.loadError'
export const _tansaLoadError = createAction(ACTION_TANSA_LOAD_ERROR)

export const tansaLoadError = withSideEffects(_tansaLoadError, errorAction)

const initialState = {
  initialized: false,
  loading: false,
  error: null,
}

export default createReducer(initialState, [
  [ACTION_INIT, () => always(initialState)],
  [ACTION_INIT_TANSA, (_) => assoc('loading', true)],
  [
    ACTION_TANSA_LOAD_SUCCESS,
    (_) =>
      pipe(
        assoc('loading', false),
        assoc('initialized', true)
      ),
  ],
  [
    ACTION_TANSA_LOAD_ERROR,
    (payload) =>
      pipe(
        assoc('loading', false),
        assoc('initialized', false),
        assoc('error', payload)
      ),
  ],
])

export const getTansaLoading = path(['tansa', 'loading'])
export const getTansaInitialized = path(['tansa', 'initialized'])
export const getTansaError = pathOr(null, ['tansa', 'error'])
export const getTansaInitializedOrFailed = either(
  getTansaInitialized,
  (state) => getTansaError(state) !== null
)
